import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import ResponsivePagination from 'react-responsive-pagination';
import { Link, NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { set } from 'date-fns';
import CurrencyFormat from 'react-currency-format';
import { useSelector } from 'react-redux';
import { formatDate } from '../../../../Config/formatDate';

const filterTypes = [
    { name: "All", value: "" },
    { name: "Created", value: "created" },
    { name: "Used", value: "used" },
    { name: "Redeemed", value: "redeemed" },
    { name: "Expired", value: "expired" }
]

export default function Feedback() {
    const param = useParams()
    const dataval = useSelector((state) => state.dataValue)
    const searchParams = new URLSearchParams(window.location.search)
    let navigate = useNavigate()
    const location = useLocation()
    const valueInt = {
        title: '',
        value: '',
        units: 1,
    }
    const [loading, setloading] = useState(true)
    const [value, setvalue] = useState(valueInt)
    const [list, setlist] = useState([])
    const [chargerData, setChargerData] = useState({})

    let limit = 20
    const [params, setParams] = useState({
        // sort_key: searchParams.get("sort_key") || "",
        // sort_value: searchParams.get("sort_value") || "asc",
        search: searchParams.get("search") || "",
        page: searchParams.get("page") || 1,
        status: searchParams.get("status") || "",
    })
    const [count, setCount] = useState(1)
    const [searchProgress, setsearchProgress] = useState(false)
    const [reply, setReply] = useState({
        id: "",
        reply: "",
        show: false
    })
    const [replyData, setReplyData] = useState({
        id: "",
        show: false,
        data: []
    })

    const setparam = (key, val) => {
        searchParams.set(key, val)
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
    }
    const deleteparam = (key) => {
        searchParams.delete(key)
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
    }
    const [search, setsearch] = useState(searchParams.get("search") || "")
    const searchUser = (e) => {
        deleteparam("page")
        setsearch(e.target.value)
        if (e.target.value == "") {
            setParams({ ...params, 'page': 1, 'search': "" })
            deleteparam("search")
        } else {
            setparam("search", e.target.value)
        }
    }
    useEffect(() => {
        // deleteparam("page")
        const delayDebounceFn = setTimeout(() => {
            if (search != "") {
                setsearchProgress(true)
                setParams({ ...params, page: 1, search: search })
                setparam('search', search)
            }

        }, 1000)

        return () => clearTimeout(delayDebounceFn)
    }, [search])

    const onSelectChange = (e) => {
        if (e.target.value) {
            setParams({ ...params, [e.target.name]: e.target.value, page: 1 })
            setparam([e.target.name], e.target.value)
            setparam("page", 1)
        } else {
            setParams({ ...params, [e.target.name]: "", page: 1 })
            deleteparam(e.target.name)
        }
    }
    const onPageChangeFunction = (number) => {
        if (number !== parseInt(params.page)) {
            setParams({ ...params, page: number })
            setparam("page", number)
            setloading(true)
        } else {
            setparam("page", number)
            setParams({ ...params, page: number })
        }
    }
    // getFeedbackList
    const getFeedbackList = (id, param) => {
        Api.GetApi(`${endPoints.FEEDBACKLIST}/${id}${param}`, "").then(res => {
            setsearchProgress(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                setloading(false)
                if (res.data?.data?.result.length) {
                    let result = res.data?.data?.result.map((data) => ({ ...data, checked: false }))
                    setlist(result || [])
                }
                if (res.data?.data?.charger) {
                    setChargerData(res.data?.data?.charger)
                }

                let newCount = Math.ceil(parseInt(res.data?.data?.totalCount?.count) / limit)
                if (newCount !== 0) {
                    let items = [];
                    for (let number = 1; number <= newCount; number++) {
                        items.push(number);
                    }
                    setCount(items)
                } else {
                    setCount(1)
                }
            }
        })
    }

    const replyFeedback = (id) => {
        setReply({
            ...reply,
            id: id,
            show: true
        })
    }

    const viewReply = (data) => {
        setReplyData({
            ...replyData,
            id: data._id,
            show: !replyData.show,
            data: data.replies
        })
    }

    const editReply = (rep) => {
        let arr = replyData.data.map((data) => {
            if (data._id == rep._id) {
                data.edit = !data.edit
            } else {
                data.edit = false
            }
            return data
        })
        console.log("arrrr", arr)
        setReplyData({
            ...replyData,
            data: arr
        })
    }
    const deleteReply = (rep) => {
        let arr = replyData.data.map((data) => {
            if (data._id == rep._id) {
                data.delete = !data.delete
            } else {
                data.delete = false
            }
            return data
        })
        console.log("arrrr", arr)
        setReplyData({
            ...replyData,
            data: arr
        })
    }
    const onEditReply = (e, rep) => {
        let arr = replyData.data.map((data) => {
            if (data._id == rep._id) {
                data.newMsg = e.target.value
            }
            return data
        })
        console.log("arrrr", arr)
        setReplyData({
            ...replyData,
            data: arr
        })
    }
    const cancelEdit = (id, type) => {
        let arr = replyData.data.map((data) => {
            data.edit = false
            if (type == "update") {
                if (data._id == id) {
                    data.message = data.newMsg
                }
            }
            return data
        })
        console.log("arrrr", arr)
        setReplyData({
            ...replyData,
            data: arr
        })
    }

    const confirmDelete = () => {
        const updatedArr = replyData.data.filter(item => !item.delete);
        replyData.data.filter((x) => x.delete).map((data) => {
            Api.GetApi(`${endPoints.FEEDBACKDELETE}/${data._id}`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                    setloading(false)
                } else {
                    setloading(false)
                    Api.Alert(res.data.data, "success")
                    setReplyData({
                        ...replyData,
                        data: updatedArr,
                        show: updatedArr && updatedArr.length > 0 ? true : false
                    })
                    if (param.id) {
                        getFeedbackList(param.id, location.search)
                    }
                }
            })
        })
    }

    const cancelDelete = () => {
        let arr = replyData.data.map((data) => {
            data.delete = false
            return data
        })
        console.log("arrrr", arr)
        setReplyData({
            ...replyData,
            data: arr
        })
    }
    const updateReply = () => {
        let body = {}
        replyData.data.filter((x) => x.edit).map((data) => {
            if (!data.newMsg) {
                Api.Alert("Please enter reply", "error")
            } else {
                body = {
                    id: data._id,
                    reply: data.newMsg
                }
                console.log("reply body", body)
                Api.PostApi(endPoints.FEEDBACKEDIT, body).then(res => {
                    if (res.error === true) {
                        Api.Alert(res.response.data.error, "error")
                        setloading(false)
                    } else {
                        setloading(false)
                        Api.Alert(res.data.data, "success")
                        cancelEdit(data._id, "update")
                    }
                })
            }
        })
    }

    const sendReply = () => {
        if (!reply.msg) {
            Api.Alert("Please enter reply", "error")
        } else {
            let body = {
                id: reply.id,
                reply: reply.msg
            }
            console.log("reply", body)
            Api.PostApi(endPoints.FEEDBACKREPLY, body).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                    setloading(false)
                } else {
                    setloading(false)
                    Api.Alert(res.data.data, "success")
                    getFeedbackList(param.id, location.search)
                    setReply({
                        id: "",
                        reply: "",
                        show: false
                    })
                }
            })
        }
    }
    const hideReply = (id, val) => {
        Api.PutApi(endPoints.FEEDBACKHIDE, { id: id, hide: val }, "").then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                setloading(false)
                Api.Alert("Updated sucessfully", "success")
                getFeedbackList(param.id, location.search)
            }
        })
    }

    const toggleFeedback = (e, id) => {
        hideReply(id, e.target.checked ? false : true)
    }

    const cancelReply = () => {
        setReply({
            id: "",
            reply: "",
            show: false
        })
    }


    useEffect(() => {
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
        if (param.id) {
            getFeedbackList(param.id, location.search)
        }
    }, [params])

    console.log("list", list)
    console.log("replyData", replyData)


    return (
        <main id="main" className="main">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>Customers feedback</h1>
            </div>
            {loading ?
                <div className="loader-line"></div> :
                <div className="row">
                    <div className='col-12'>
                        <div className="card">
                            <div className="card-body py-3">
                                <div className='mb-3'>
                                    <h4>
                                        <NavLink to="/charging-station" className="d-inline-flex gap-3"> <Icon.ArrowLeft />
                                            <span><Icon.EvStation className="me-2 text-primary" /> {chargerData?.endpoint}</span>
                                        </NavLink>
                                    </h4>
                                </div>

                                {list && list.length > 0 ?
                                    <>
                                        {list.map((data, index) => {
                                            const stars = [];
                                            for (let i = 1; i <= 5; i++) {
                                                const starValue = i - 0.5;
                                                const isHalfStar = data?.rating >= starValue && data?.rating < i;
                                                const isFilledStar = data?.rating >= i;
                                                stars.push(
                                                    isFilledStar ? "StarFill" : isHalfStar ? "StarHalf" : "Star"
                                                );
                                            }
                                            return (
                                                <div className='feedbackTable' key={index}>
                                                    <div className='feedback_header'>
                                                        <div className='feedback_header__left'>
                                                            <div className='d-flex mb-2 align-items-center'>
                                                                <h5 className='mb-0 me-3'>{data?.user?.name}</h5>
                                                                <div className='starRatingHolder'>
                                                                    {stars.map((iconName, iconIndex) => {
                                                                        return <React.Fragment key={iconIndex}>
                                                                            {iconName === "StarFill" ? <Icon.StarFill /> : iconName === "StarHalf" ? <Icon.StarHalf /> : <Icon.Star />}
                                                                        </React.Fragment>
                                                                    })}
                                                                </div>

                                                            </div>
                                                            <p className='mb-0'>{data?.user?.email}</p>
                                                            <p className='mb-0'>{data?.user?.country_code || ""} {data?.user?.phone_number}</p>
                                                        </div>
                                                        <div className='feedback_header__right d-flex align-items-center gap-3'>
                                                            <p><strong>{data?.createdAt ? formatDate(data?.createdAt) : "--"}</strong></p>

                                                            <span title={data?.is_hidden ? "Hidden" : "Visible"}>
                                                                <Form.Check
                                                                    className='mb-0 h5'
                                                                    type="switch"
                                                                    checked={data?.is_hidden ? false : true}
                                                                    // value={data?._id?._id}
                                                                    onChange={(e) => toggleFeedback(e, data?._id)}
                                                                />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='feedback_body'>
                                                        <div className='feedback_msg'>{data?.feedback ? `"${data?.feedback}"` : "--"}</div>
                                                        {replyData.show && replyData.id === data?._id && data?.replies && data?.replies.length ?
                                                            <div>
                                                                {replyData?.data.map((rep, index) => {
                                                                    return (
                                                                        <div className='feedback_reply' key={index}>
                                                                            {!rep.edit ?
                                                                                <>
                                                                                    <div className='d-flex align-items-center'>
                                                                                        <p className='mb-0 me-3 text-capitalize'><small>Reply by - {rep?.user_type}</small></p>
                                                                                        <p className='mb-0'><small>{rep?.replied_at ? formatDate(rep?.replied_at) : "--"}</small></p>
                                                                                        {rep.delete ?
                                                                                            <>
                                                                                                <button className='noHover text-primary ms-2' onClick={() => confirmDelete(rep._id)}><strong><small>Confirm</small></strong></button>
                                                                                                <button className='noHover text-danger' onClick={cancelDelete}><strong><small>Dismiss</small></strong></button>
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                                <button className='noHover text-primary ms-2' onClick={() => editReply(rep)}><small><Icon.PencilFill /></small></button>
                                                                                                <button className='noHover text-danger' onClick={() => deleteReply(rep)}><small><Icon.TrashFill /></small></button>
                                                                                            </>
                                                                                        }
                                                                                    </div>
                                                                                    <div className='feedback_msg'>{rep.message ? `"${rep.message}"` : "--"}</div>
                                                                                </>
                                                                                :
                                                                                <div className=''>
                                                                                    <p className='mb-0 me-3 text-capitalize'><small>Reply by - {rep?.user_type}</small></p>
                                                                                    <textarea className='form-control mb-3' placeholder='Reply' defaultValue={rep.newMsg || rep.message} onChange={(e) => onEditReply(e, rep)} />
                                                                                    <button className='btn btn-success btn-sm' onClick={updateReply}>Update</button>
                                                                                    <button className='btn btn-outline-danger btn-sm ms-3' onClick={() => cancelEdit(rep._id, "")}>Cancel</button>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            : null
                                                        }
                                                    </div>
                                                    <div className='feedback_footer'>
                                                        {reply.show && reply.id === data?._id ?
                                                            <div className=''>
                                                                <textarea className='form-control mb-3' placeholder='Reply' onChange={(e) => setReply({ ...reply, msg: e.target.value })} />
                                                                <button className='btn btn-success btn-sm' onClick={sendReply}>Submit</button>
                                                                <button className='btn btn-outline-danger btn-sm ms-3' onClick={cancelReply}>Cancel</button>
                                                            </div>
                                                            :
                                                            <div>
                                                                <button className='btn btn-primary btn-sm' onClick={() => replyFeedback(data?._id)}>Reply</button>
                                                                {data?.replies.length ?
                                                                    <button className='link ms-3 text-primary' onClick={() => viewReply(data)}>{replyData.show && replyData.id === data?._id ? "Hide Reply" : "View Reply"}</button>
                                                                    : null
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </>
                                    :
                                    <div className='text-center py-5'>
                                        <h3>No result found</h3>
                                    </div>
                                }
                                <div style={{ maxWidth: "500px" }}>
                                    {searchProgress ?
                                        <div className='loadingTd' style={{ maxWidth: "100px" }}><div className='bar'></div>
                                        </div> :
                                        <ResponsivePagination
                                            current={parseFloat(searchParams.get("page"))}
                                            total={count.length}
                                            onPageChange={onPageChangeFunction}
                                            disabled={params.page === count.length}
                                            // maxWidth={500}
                                            className={"pagination "}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }


        </main >
    )
}
